import React, { useState } from 'react';
import { M as MenuItem } from './MenuItem-JKaXddS7.js';

const Menu = ({ items }) => {
    const [active, setActive] = useState(null);
    const onFocus = (dataLabel) => {
        setActive(dataLabel);
    };
    return (React.createElement("ul", { className: "top-nav" }, items.map((item, index) => (React.createElement(MenuItem, { key: item.item_id, item: item, position: index + 1, active: active, onFocus: onFocus })))));
};

export { Menu as M };
//# sourceMappingURL=Menu--Y-zXYsK.js.map
